document.addEventListener("DOMContentLoaded", () => {

    let selectedVariant = null;
    let selectedQuantity = 1;

    const amounts = document.querySelectorAll(".amount");
    const donateButton = document.getElementById("donateButton");
    const selectedAmount = document.getElementById("selectedAmount");
    const selectedImpact = document.getElementById("selectedImpact");
    const customInput = document.getElementById("customAmountInput");

    const customVariant = donateButton.dataset.customVariant;
    const minCustom = customInput ? Number(customInput.min || 1) : 1;

    function enableDonateButton() {
        donateButton.disabled = false;
        donateButton.classList.add("enabled");
    }

    function disableDonateButton() {
        donateButton.disabled = true;
        donateButton.classList.remove("enabled");
    }

    function selectPreset(button) {

        amounts.forEach(item => {
            item.classList.remove("active");
            item.setAttribute("aria-pressed", "false");
        });

        button.classList.add("active");
        button.setAttribute("aria-pressed", "true");

        if (customInput) customInput.value = "";

        selectedVariant = button.dataset.variant;
        selectedQuantity = 1;

        selectedAmount.innerHTML = "$" + button.dataset.price;
        selectedImpact.innerHTML = button.dataset.impact;

        enableDonateButton();
    }

    function selectCustomAmount(value) {

        const amount = Math.floor(Number(value));

        amounts.forEach(item => {
            item.classList.remove("active");
            item.setAttribute("aria-pressed", "false");
        });

        if (!amount || amount < minCustom) {
            selectedVariant = null;
            selectedAmount.innerHTML = "Selecciona una donación";
            selectedImpact.innerHTML = `El monto mínimo es $${minCustom}.`;
            disableDonateButton();
            return;
        }

        if (!customVariant) {
            selectedVariant = null;
            selectedImpact.innerHTML = "El monto personalizado no está disponible en este momento.";
            disableDonateButton();
            return;
        }

        selectedVariant = customVariant;
        selectedQuantity = amount;

        selectedAmount.innerHTML = "$" + amount;
        selectedImpact.innerHTML = "Gracias por tu apoyo, cada dólar ayuda directamente en el terreno.";

        enableDonateButton();
    }

    amounts.forEach(button => {
        button.addEventListener("click", () => selectPreset(button));
    });

    if (customInput) {
        customInput.addEventListener("input", (e) => selectCustomAmount(e.target.value));
    }

    donateButton.addEventListener("click", async () => {

        if (!selectedVariant) return;

        const originalText = "Donar ahora";
        donateButton.innerHTML = "Procesando...";
        donateButton.disabled = true;

        try {

            const clearResponse = await fetch("/cart/clear.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" }
            });

            if (!clearResponse.ok) throw new Error("No se pudo vaciar el carrito");

            const addResponse = await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: Number(selectedVariant),
                    quantity: selectedQuantity
                })
            });

            if (!addResponse.ok) {
                const errorData = await addResponse.json().catch(() => null);
                console.error("Error al agregar al carrito:", errorData);
                throw new Error("No se pudo agregar la donación al carrito");
            }

            window.location.href = "/checkout";

        } catch (error) {

            console.error(error);
            donateButton.innerHTML = "Error, intenta de nuevo";

            setTimeout(() => {
                donateButton.innerHTML = originalText;
                donateButton.disabled = false;
            }, 2500);

        }

    });

    // CARRUSEL DE COLABORADORES
    const carousel = document.getElementById("collabCarousel");

    if (carousel) {

        let isDown = false;
        let startX;
        let scrollStart;
        let autoScrollTimer = null;
        let resumeTimeout = null;

        function startAutoScroll() {
            stopAutoScroll();
            autoScrollTimer = setInterval(() => {
                const maxScroll = carousel.scrollWidth - carousel.clientWidth;
                if (carousel.scrollLeft >= maxScroll - 1) {
                    carousel.scrollLeft = 0;
                } else {
                    carousel.scrollLeft += 0.6;
                }
            }, 20);
        }

        function stopAutoScroll() {
            if (autoScrollTimer) {
                clearInterval(autoScrollTimer);
                autoScrollTimer = null;
            }
        }

        function scheduleResume() {
            clearTimeout(resumeTimeout);
            resumeTimeout = setTimeout(startAutoScroll, 2500);
        }

        carousel.addEventListener("mousedown", (e) => {
            isDown = true;
            carousel.classList.add("dragging");
            startX = e.pageX - carousel.offsetLeft;
            scrollStart = carousel.scrollLeft;
            stopAutoScroll();
        });

        carousel.addEventListener("mouseleave", () => {
            isDown = false;
            carousel.classList.remove("dragging");
            scheduleResume();
        });

        carousel.addEventListener("mouseup", () => {
            isDown = false;
            carousel.classList.remove("dragging");
            scheduleResume();
        });

        carousel.addEventListener("mousemove", (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - carousel.offsetLeft;
            const walk = (x - startX) * 1.2;
            carousel.scrollLeft = scrollStart - walk;
        });

        carousel.addEventListener("touchstart", () => {
            stopAutoScroll();
        }, { passive: true });

        carousel.addEventListener("touchend", () => {
            scheduleResume();
        });

        startAutoScroll();
    }

    // VER MÁS / VER MENOS FACTURAS
    const toggleFacturasBtn = document.getElementById("toggleFacturas");
    const timelineList = document.getElementById("timelineList");

    if (toggleFacturasBtn && timelineList) {
        toggleFacturasBtn.addEventListener("click", () => {
            const expanded = timelineList.classList.toggle("expanded");
            toggleFacturasBtn.textContent = expanded ? "Ver menos" : "Ver más facturas";
        });
    }

// COMPARTIR CAUSA
    const shareBtn = document.getElementById("shareCausaBtn");

    if (shareBtn) {
        shareBtn.addEventListener("click", async () => {
            const shareData = {
                title: "Ayuda humanitaria para Venezuela",
                text: "Ayuda a las familias afectadas por los terremotos en Venezuela. Cada donación cuenta.",
                url: window.location.href
            };

            if (navigator.share) {
                try {
                    await navigator.share(shareData);
                } catch (e) {}
            } else {
                const waUrl = "https://wa.me/?text=" + encodeURIComponent(shareData.text + " " + shareData.url);
                window.open(waUrl, "_blank");
            }
        });
    }

});